// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"1660":"41117821","5378":"edb30248","5928":"41117821"}[chunkId] + ".chunk.css";
};